"use client";

import { type ReactNode } from "react";
import { VisualizationChatClientPluginProvider } from "@/lib/ai/visualization/client/chat-client-plugin";
import { VisualizationUiProvider } from "@/lib/ai/visualization/client/ui-context";

type Props = {
  children: ReactNode;
  isVisualizationEnabled: boolean;
  setVisualizationEnabled: (enabled: boolean) => void;
};

/**
 * AI side panel の thread 表示へ visualization plugin を差し込む。
 *
 * @remarks
 * side panel は page と同じ visualization preference を使うため、thread UI と
 * plugin host を同じ `VisualizationUiProvider` 配下へまとめる。
 */
export function AiSidePanelThreadSurface({
  children,
  isVisualizationEnabled,
  setVisualizationEnabled,
}: Props) {
  return (
    <VisualizationUiProvider
      isVisualizationEnabled={isVisualizationEnabled}
      setVisualizationEnabled={setVisualizationEnabled}
    >
      <VisualizationChatClientPluginProvider>
        {children}
      </VisualizationChatClientPluginProvider>
    </VisualizationUiProvider>
  );
}
